<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Input, Text, Token } from '@Shelly/shelly-design-system';
	import { _init_notifications } from '../../../../../../../helpers/init_notification_actions';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let sceneData: any;

	const phoneNotificationsIcons = {
		push: 'fas fa-bells',
		alarm: 'fas fa-siren-on',
	};
	let selectList: [] | any[] =
		_init_notifications.find((el) => el?.props?.id === sceneData.notificationAction.type)?.props
			?.values || [];

	let val =
		selectList?.find((el) => el.msg_type === sceneData.notificationAction.msg_type)?.msg_type ||
		undefined;

	const handle_radio_choice = (new_val) => {
		val = new_val;
		sceneData.notificationAction.msg_type = val;
	};
</script>

<Text element="h2" class="mb-s mt-l">
	{$format('notification_settings_title', {
		default: 'Notification settings',
	})}
</Text>

<Input
	aria-label={$format('input_phone_notification', { default: 'Phone notification message' })}
	size="m"
	bind:value={sceneData.notificationAction.msg}
	icon="fas fa-bell"
	info={$format('phone_notification_example', {
		default: 'Example: My scene is triggered!',
	})}
	id="input-i4qwd9s"
/>

<div class="d-flex flex-wrap mt-s">
	{#each selectList as _val, i}
		<Token
			id="token-f32wvcz"
			class={classMap({ 'mr-s': i < selectList.length - 1 })}
			title={$format(_val.i18n)}
			size="m"
			value={_val.msg_type}
			selected={val === _val.msg_type}
			icon={phoneNotificationsIcons[_val.msg_type]}
			on:click={() => handle_radio_choice(_val.msg_type)}
		/>
	{/each}
</div>
